import api from './index'
import { axios } from '@/utils/request'
import {
  useMock,
  mockGetOverView,
  mockAsRateInfo,
  mockLendingInfo,
  mockRepayInfo,
  mockSettleTypeInfo
} from "./_mock";


/**
 * Homepage header four info items
 * @param  {Object} parameter [description]
 * @return {[type]}           [description]
 */
export function getOverView (parameter = {}) {
  if (useMock()) return Promise.resolve(mockGetOverView)
  return axios({
    url: '/statistics/overview',
    method: 'post',
    data: parameter
  })
}

/**
 * Conversion rate -- Progress bar
 * @param  {Object} parameter [description]
 * @return {[type]}           [description]
 */
export function getConversionRate (parameter = {}) {
  if (useMock()) return Promise.resolve(mockAsRateInfo)
  return axios({
    url: '/statistics/asRateInfo',
    method: 'post',
    data: parameter
  })
}

/**
 * Loan disbursement in last 10 days -- Line chart
 * @param  {Object} parameter [description]
 * @return {[type]}           [description]
 */
export function getLendingCountByDate (parameter = {}) {
  if (useMock()) return Promise.resolve(mockLendingInfo)
  return axios({
    url: '/statistics/lendingInfo',
    method: 'post',
    data: parameter
  })
}

/**
 * Same day repayment status -- Liquid chart
 * @param  {Object} parameter [description]
 * @return {[type]}           [description]
 */
export function getRepayCount (parameter = {}) {
  if (useMock()) return Promise.resolve(mockRepayInfo)
  return axios({
    url: '/statistics/repayInfo',
    method: 'post',
    data: parameter
  })
}

/**
 * Orders grouped by settlement status -- Pie chart
 * @param  {Object} parameter [description]
 * @return {[type]}           [description]
 */
export function getLoanStatusCount (parameter = {}) {
  if (useMock()) return Promise.resolve(mockSettleTypeInfo)
  return axios({
    url: '/statistics/settleTypeInfo',
    method: 'post',
    data: parameter
  })
}

export function getPartConversionRate (parameter = {}) {
  if (useMock()) return Promise.resolve(mockAsRateInfo)
  return axios({
    url: '/statistics/asRateInfoPart',
    method: 'post',
    data: parameter
  })
}
export function getOneKeyOpen (parameter = {}) {

  return axios({
    url: '/user/get_one_key_open',
    method: 'post',
    data: parameter
  })
}
export function saveOneKeyOpen (parameter = {}) {
  return axios({
    url: '/user/save_one_key_open',
    method: 'post',
    data: parameter
  })
}